export default {"src":"/_next/static/media/baron_logo.b51f3019.svg","height":172,"width":369,"blurWidth":0,"blurHeight":0};